module.exports = __webpack_public_path__ + "static/media/bavarian.592cc02e.png";